// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminPieCharts_wrapper__XG9iT"};